import {IAugmentedJQuery, IController, IFormController, IOnChangesObject, ISCEService, ITimeoutService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Autentisering} from "felles/tjenester/Autentisering";
import _ from "lodash";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";
import {FellesAutentiseringsRessurs} from "../../tjenester/ressurser/FellesAutentiseringsRessurs";
import {MeldingTilBruker, Varighet} from "../../tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";

const debug:Debugger = require('debug')('PassordAutentiseringBasis');


/**
 * Basiskontroller for brukernavn/passord/otp autentisering.
 * Viser brukernavn/passord dialog i ett steg - se tidliger committ for versjon som viser dette i to steg
 */
export abstract class PassordAutentiseringBasis implements IController {

    constructor(private autentisering: Autentisering,
                private fellesAutentiseringRes: FellesAutentiseringsRessurs,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private $timeout:ITimeoutService,
                private $sce: ISCEService) {
    }

    forhåndsutfyltBrukernavn: string; //satt via bindings, optional - hopper over brukernavn-steget dersom angitt
    tokenvarighet: l.Tokenvarighet; //satt via bindings, optional - bruker medium dersom ikke satt
    /** Kalles når en av brukernavn/passord autentiseringsmekanismene ativeres */
    vedValgt: (arg:{aktivert:boolean;}) => void; //satt via bindings
    /** Kalles når server krever at bruker oppgraderer autentiseringsmekanisme til en annen mekanisme enn denne kontrolleren klarer å håndtere */
    vedKreverOppgraderingTil: (arg:{autentiseringsmetode:l.Autentiseringsmetode;}) => void; //satt via bindings
    /** Kalles når bruker har valgt å logge inn i Lederplan (SP3) */
    vedAutentisert: (args: { autentisert: l.AutentisertOkModell }) => void; //satt via bindings

    modell = new AutentiseringSkjemaModell();
    autentiseringFeilet = false;
    steg:'brukernavn'|'totp'|'totpReservekode'|'sms'|'smsOtpReservekode' = 'brukernavn';
    autentiserer = false;

    private skjema:IFormController

    haandterBrukerPassordSkjema(skjema: IFormController) {
        this.skjema = skjema;
        //if (this.steg == 'brukernavn') return this.gåTilPassordSteg();
        return this.hentBrukerinfoOgBestemNesteSteg();
    }

    stoetterOppgraderingTilSmsOtp(){
        return _.includes(this.modell.kreverOppgarderingTilAutentiseringsmetoder, l.Autentiseringsmetode.smsOtp);
    }

    stoetterOppgraderingTilTotp(){
        return _.includes(this.modell.kreverOppgarderingTilAutentiseringsmetoder, l.Autentiseringsmetode.totpOtp);
    }

    stoetterOppgraderingTilCriiptoOpenId(){
        return _.includes(this.modell.kreverOppgarderingTilAutentiseringsmetoder, l.Autentiseringsmetode.criiptoOpenId);
    }

    endreTilTotp(){
        this.nullstillAutentiseringsstatus();
        this.modell.spesifikasjon.totpOtpKode = null;
        this.modell.spesifikasjon.smsOtpKode = null;
        this.modell.spesifikasjon.forespurtMetode = l.Autentiseringsmetode.totpOtp;
        this.logginnLederplan();
    }

    endreTilSmsOtp(){
        this.nullstillAutentiseringsstatus();
        this.modell.spesifikasjon.totpOtpKode = null;
        this.modell.spesifikasjon.smsOtpKode = null;
        this.modell.spesifikasjon.forespurtMetode = l.Autentiseringsmetode.smsOtp;
        this.logginnLederplan();
    }

    gaaTilbake(){
        this.nullstillAutentiseringsstatus();
        this.modell.spesifikasjon.totpOtpKode = null;
        this.modell.spesifikasjon.forespurtMetode = l.Autentiseringsmetode.passord;
        this.steg = 'brukernavn';
        this.vedValgt({aktivert:false});
    }

    nullstillAutentiseringsstatus() {
        this.autentiseringFeilet = false;
        this.autentiserer = false;
    }

    // totp

    gaaTilTotpSteg(){
        this.nullstillAutentiseringsstatus();
        this.modell.spesifikasjon.totpOtpKode = null;
        this.modell.spesifikasjon.forespurtMetode = l.Autentiseringsmetode.totpOtp;
        this.steg = 'totp';
        this.vedValgt({aktivert:true});
    }

    gaaTilLoggInnMedTotpReserverkode(){
        this.nullstillAutentiseringsstatus();
        this.modell.spesifikasjon.forespurtMetode = null;
        this.modell.totpReservekode = null;
        this.steg = 'totpReservekode';
    }

    autentiserMedTotpReservekode(skjema: IFormController) {
        this.autentiserer = true; //merk at vi ikke resetter denne i en .finally blokk da vi må forhindre at knappen blir trykket på mens autentiserinOk callbacket blir behandlet
        this.autentisering.autentiserMedTotpReservekode(
            this.modell.somTotpReservekodeInnloggingsSpesifikasjon(),
            autentisert => this.autentiseringOk(autentisert, skjema),
            respons => this.vedAutentiseringFeilet(respons, skjema)
        );
    }

    // sms

    gaaTilSmsOtpSteg(otpSmsSendtTil:string){
        this.nullstillAutentiseringsstatus();
        this.modell.spesifikasjon.smsOtpKode = null;
        this.modell.spesifikasjon.forespurtMetode = l.Autentiseringsmetode.smsOtp;
        this.modell.otpSmsSendtTil = otpSmsSendtTil;
        this.steg = 'sms';
        this.vedValgt({aktivert:true});
    }

    sendNySmsOtpKode(){
        this.modell.spesifikasjon.smsOtpKode = null;
        this.modell.spesifikasjon.forespurtMetode = l.Autentiseringsmetode.smsOtp;
        this.steg = 'sms';
        this.logginnLederplan()
            .then(() => {
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Ny engangskode sendt på SMS'), Varighet.timeout_eller_navigasjon);
            });
    }

    gaaTilLoggInnMedSmsOtpReserverkode(){
        this.nullstillAutentiseringsstatus();
        this.modell.smsOtpReservekode = null;
        this.modell.spesifikasjon.forespurtMetode = null;
        this.steg = 'smsOtpReservekode';
    }

    autentiserMedSmsOtpReservekode(skjema: IFormController) {
        this.autentiserer = true; //merk at vi ikke resetter denne i en .finally blokk da vi må forhindre at knappen blir trykket på mens autentiserinOk callbacket blir behandlet
        this.autentisering.autentiserMedSmsOtpReservekode(
            this.modell.somSmsOtpReservekodeInnloggingsSpesifikasjon(),
            autentisert => this.autentiseringOk(autentisert, skjema),
            respons => this.vedAutentiseringFeilet(respons, skjema)
        );
    }

    $onChanges(changes: IOnChangesObject): void {
        dersomChangesInneholder(changes, 'tokenvarighet',
                varighet => this.modell.spesifikasjon.tokenvarighet = varighet)
        dersomChangesInneholder(changes, 'forhåndsutfyltBrukernavn',
                brukernavn => this.settBrukernavnOgGåTilPassordsteg(brukernavn))
    }

    /*
   ved sidelasting blir ikke ng-model populert med autofill verdi for brukernavn (testet på chrome/osx)
   har ikke funnet noen måte å løse dette - later til at den autoutfylte verdien ikke er tilgjengelig i js
   før bruker har interagert med siden.
   $onInit(): void {
        const inp = this.$element.find('input[name=brukernavn]');
        this.$timeout(()=>{
            debug('$onInit timeout', this.$scope)
            debug('$onInit val: %s # %s', inp.val(), this.brukernavn)
            debug('$onInit brukernavnSkjema', this.$scope['brukernavnSkjema'].brukernavn)
            debug('$onInit querySelector', document.querySelector('input[name=brukernavn]').value)
            debug('$onInit querySelector', document.querySelector('input[name=brukernavn]'))
            window['kai']= inp;
        }, 6000)
    }*/

    //subklasse kontrakt

    /** Returnerer passordfeltet. */
    abstract passordElement():IAugmentedJQuery;

    //private hjelpemetoder

    /*private gåTilPassordSteg() {
        this.steg = 'passord';
        this.vedValgt({aktivert:true});
        //gi fokus til passordfelt, med timeout slik at feltet rekker å bli synlig
        this.$timeout(() => this.passordElement().focus(), 100);
    }*/

    private hentBrukerinfoOgBestemNesteSteg() {
        this.autentiserer = true; //merk at vi ikke resetter denne i en .finally blokk da vi må forhindre at knappen blir trykket på mens autentiserinOk callbacket blir behandlet
        this.autentiseringFeilet = false;
        this.logginnLederplan()
    }

    logginnLederplan() {
        this.autentiserer = true; //merk at vi ikke resetter denne i en .finally blokk da vi må forhindre at knappen blir trykket på mens autentiserinOk callbacket blir behandlet
        return this.autentisering.autentiser(this.modell.somInnloggingsSpesifikasjon())
            .then(autentisert => this.autentiseringOk(autentisert, this.skjema))
            .catch((respons: l.AutentiseringResponsModell) => {
                if (respons.status === l.AutentiseringStatus.kreverOppgradering)
                    this.oppgraderingPåkrevet(respons);
                else this.vedAutentiseringFeilet(respons, this.skjema);
            });
    }

    private oppgraderingPåkrevet(respons: l.AutentiseringResponsModell){
        this.nullstillAutentiseringsstatus();
        this.modell.kreverOppgarderingTilAutentiseringsmetoder = respons.kreverOppgarderingTilAutentiseringsmetoder;
        //har vi forespurt en spesifikk metode?
        //test for sms først da vi skiller mellom smsOtp og totp via otpSmsSendtTil-feltet som er ikke-null ved smsOtp
        if(_(respons.kreverOppgarderingTilAutentiseringsmetoder).includes(l.Autentiseringsmetode.smsOtp) && _.isString(respons.otpSmsSendtTil))
            return this.gaaTilSmsOtpSteg(respons.otpSmsSendtTil);
        if(_(respons.kreverOppgarderingTilAutentiseringsmetoder).includes(l.Autentiseringsmetode.totpOtp))
            return this.gaaTilTotpSteg();

        this.vedKreverOppgraderingTil({autentiseringsmetode:l.Autentiseringsmetode.criiptoOpenId})
    }

    private autentiseringOk(autentisert: l.AutentisertOkModell, skjema: IFormController){
        skjema.$setPristine();
        this.vedAutentisert({autentisert: autentisert});
    }

    private vedAutentiseringFeilet(respons: l.AutentiseringResponsModell, skjema: IFormController){
        this.nullstillAutentiseringsstatus();
        this.autentiseringFeilet = true;
        //@todo vise feilmelding basert på respons.status?
        debug("autentiseringFeilet", respons)
        skjema.$setPristine();
    }

    private settBrukernavnOgGåTilPassordsteg(brukernavn: string) {
        this.modell.spesifikasjon.brukernavn = brukernavn;
        //this.steg = 'passord';
        this.steg = 'brukernavn';
    }
}


export class AutentiseringSkjemaModell{

    spesifikasjon: l.InnloggingsSpesifikasjon = {brukernavn: '', passord: '', tokenvarighet: l.Tokenvarighet.medium, forespurtMetode: l.Autentiseringsmetode.passord};
    totpReservekode: string;
    smsOtpReservekode: string;
    otpSmsSendtTil: string;
    kreverOppgarderingTilAutentiseringsmetoder: l.Autentiseringsmetode[];

    somInnloggingsSpesifikasjon(): l.InnloggingsSpesifikasjon {
        debug('somInnloggingsSpesifikasjon', this)
        return {
            brukernavn: this.spesifikasjon.brukernavn,
            passord: this.spesifikasjon.passord,
            totpOtpKode: this.spesifikasjon.totpOtpKode,
            smsOtpKode: this.spesifikasjon.smsOtpKode,
            tokenvarighet: this.spesifikasjon.tokenvarighet,
            forespurtMetode: this.spesifikasjon.forespurtMetode
        }
    }

    somTotpReservekodeInnloggingsSpesifikasjon(): l.TotpReservekodeInnloggingsSpesifikasjon {
        return {
            brukernavn: this.spesifikasjon.brukernavn,
            passord: this.spesifikasjon.passord,
            totpReservekode: this.totpReservekode,
        };
    }

    somSmsOtpReservekodeInnloggingsSpesifikasjon(): l.SmsOtpReservekodeInnloggingsSpesifikasjon {
        return {
            brukernavn: this.spesifikasjon.brukernavn,
            passord: this.spesifikasjon.passord,
            smsOtpReservekode: this.smsOtpReservekode,
        };
    }
}
